export default __webpack_public_path__ + "static/media/bootstrap-icon.aaba30bc.png";